import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { getImgUrl, limitText, isMobile, getUrl2 } from "../../Utility/Utility";
import SimpleSlider from "../SimpleSlider/SimpleSlider";
import TagManager from 'react-gtm-module';
import Deals from "../Deals/Deals";
import YouTube from "react-youtube";
import ReactPlayer from "react-player";
import "./UI.css";
import { APP_NAME } from "../../config";

export const App_input = (props) => {
  const name = props.name != undefined ? props.name : "";
  const label = props.label != undefined ? props.label : "";
  const cssInputClass =
    props.cssInputClass != undefined ? props.cssInputClass : "";
  const id = props.id != undefined ? props.id : "";
  //const  id =  APP_NAME + "-input-" + new Date().getTime();
  let cssWrapperClass =
    APP_NAME +
    "-input-component  " +
    APP_NAME +
    " input-" +
    name +
    "-component " +
    cssInputClass;

  let labelField = "";
  if (label !== "") {
    cssWrapperClass += APP_NAME + "-input-has-label ";
    labelField = <label htmlFor={id}>{label}</label>;
  }
  let html = (
    <div className={cssWrapperClass}>
      {labelField}
      <input
        id={id}
        data-validation-type={props.validationType}
        onClick={props.click}
        onChange={props.handleChange}
        onBlur={props.handleBlur}
        type={props.type}
        name={props.name}
        className={cssInputClass}
        placeholder={props.placeholder}
        value={props.val}
        maxLength={props.maxLength}
      />
    </div>
  );
  if (props.type === "hidden") {
    html = (
      <input
        type={props.type}
        name={name}
        className={cssInputClass}
        placeholder={props.placeholder}
        value={props.val}
      />
    );
  }
  return html;
};

export const Select = (props) => {
  let name = props.name;
  let cssWrapperClass =
    "form-input-wrapper input-" +
    name +
    "-wrapper select-" +
    name +
    "-wrapper" +
    props.cssClass;
  let cssInputClass = "select-" + name + " ";
  let labelProp = props.label;
  let labelField = "";
  let id = "ac-input-" + new Date().getTime();

  if (labelProp !== undefined) {
    cssWrapperClass += " inputHasLabel ";
    labelField = <label htmlFor={id}> {props.label} </label>;
  }
  return (
    <div className={cssWrapperClass}>
      {labelField}
      <select
        onChange={props.change}
        name={props.name}
        className={cssInputClass}
      >
        {props.children};
      </select>
    </div>
  );
};

export const TopPart = (props) => {
  return (
    <header className="App-header alignCenter">
      <div className="container">
        <h1 className="App-title">{props.title}</h1>
        <p>{props.text}</p>
      </div>
    </header>
  );
};

export const Img = (props) => {
  const windowW = window.innerWidth;

  let desktopImg = props.desktopImg ? getImgUrl() + "" + props.desktopImg : "";
  let mobileImg = props.mobileImg ? getImgUrl() + "" + props.mobileImg : "";
  let html = (
    <div className={"img-wrapper " + props.imgCss}>
      <img src={desktopImg} alt="" />
    </div>
  );

  if (props.mobileImg != undefined) {
    if (windowW < 1000) {
      html = (
        <div className="img-wrapper">
          <img className="show-on-mobile" src={mobileImg} alt="" />
        </div>
      );
    }
  }
  return html;
};

const Btn = (props) => {
  const cssClass = props.cssClass ? "ac-btn " + props.cssClass : props.cssClass;

  return (
    <button className={cssClass} onClick={props.onClick}>
      {props.children}
    </button>
  );
};

export const BtnSubmit = (props) => {
  const cssClass = props.cssClass ? "ac-btn " + props.cssClass : props.cssClass;

  return (
    <button className={cssClass} onClick={props.onClick} type={props.type}>
      {props.children}
    </button>
  );
};

export const Logo = () => {
  return (
    <div className="logoWrapper">
      <Img desktopImg={"logo.svg"} />
    </div>
  );
};

export const HomeTitle = (props) => {
  const cssClass = "home-title-wrapper " + props.cssClass;
  return (
    <div className={cssClass}>
      <h2>{props.children}</h2>
      {/*<div className="title-border"></div>*/}
    </div>
  );
};

export const WeatherIcon = (props) => {
  let p = (
    <p>
      {parseInt(props.temp * 1.8 + 32)}
      <sup>o</sup>F
    </p>
  );
  let imgPath = "WeatherIcon.png";
  let weatherClass = "weather-icon-wrapper";
  if (props.temp === "149" || props.temp === "12") {
    p = <p>{parseInt(props.temp * 1.8 + 32)}</p>;
    imgPath = "WeatherIcon2.png";
    weatherClass = "weather-icon-wrapper flight-icon-wrapper";
  }
  return (
    <div className={weatherClass}>
      <Img desktopImg={imgPath} />
      <h3>{props.label}</h3>
      {p}
    </div>
  );
};

export const ResponsiveYouTubeIframe = (props) => {
  // const videoSrc = 'https://www.youtube.com/embed/'+props.vidId+'/?autoplay=1&mute=1&rel=0&loop=1&playlist=' + props.vidId;

  const youTubeOptions = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      muted: 1,
      controls: 1,
      loopPlaylists: true,
      loop: 1,
      playlist: props.vidId,
    },
  };

  return (
    <div className="responisve-iframe">
      <YouTube
        videoId={props.vidId}
        opts={youTubeOptions}
        onReady={(event) => {
          event.target.mute();
          event.target.playVideo();
        }}
      />
    </div>
  );
};

export const ResponsiveYouTubeMainIframe = (props) => {
  // const videoSrc = 'https://www.youtube.com/embed/'+props.vidId+'/?autoplay=1&mute=1&rel=0&loop=1&playlist=' + props.vidId;

  const youTubeOptions = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      muted: 1,
      controls: 0,
      loopPlaylists: true,
      loop: 1,
      playlist: props.vidId,
    },
  };

  return (
    <div className="responisve-iframe">
      <YouTube
        videoId={props.vidId}
        opts={youTubeOptions}
        onReady={(event) => {
          event.target.mute();
          event.target.playVideo();
        }}
      />
    </div>
  );
};

export const VideoSliderItem2 = (props) => {
  const youTubeOptions = {
    playerVars: {
      // https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      muted: 1,
    },
  };

  const desc = props.desc != undefined ? props.desc : "";
  const doBlank = props.doBlank != undefined ? props.doBlank : "";
  const title = props.title != undefined ? limitText(props.title, 30) : "";
  const mobileId = props.mobileId != "" ? props.mobileId : "";
  const cssClass = "cites-slider video-slider-item " + props.cssClass;

  // console.log('props.mobileId' , props.mobileId);
  // alert(mobileId);
  let target = "";
  if (doBlank) {
    target = "_blank";
  }

  let html = (
    <div className={cssClass}>
      <div className="inner">
        {/* <Link to={props.link}  target={target} className="read-more-link" /> */}
        <div className="video-img-wrapper" onClick={props.click}>
          <Img desktopImg={props.img} />
          <div className="video-play-img-wrapper">
            <Img desktopImg={"Videos/play.png"} />
          </div>
        </div>
        <div className="title-wrapper">
          <h3>{title}</h3>
        </div>

        <div className="desc-wrapper">
          <p>{limitText(desc)}</p>
        </div>

        <div className="book-now-wrappr">
          <a href={getUrl2() + props.link}>READ MORE {">>"}</a>
        </div>
      </div>
    </div>
  );

  if (isMobile()) {
    // console.log('mobileId' , mobileId);
    var ht = null;
    if (mobileId != "") {
      ht = (
        <div>
          <Img desktopImg={props.img} />
          <div className="video-play-img-wrapper">
            <Img desktopImg={"Videos/play.png"} />
          </div>
        </div>
      );
    } else {
      ht = (
        <div>
          <Img desktopImg={props.img} />
          <div className="video-play-img-wrapper">
            <Img desktopImg={"Videos/play.png"} />
          </div>
        </div>
      );
    }

    // alert('s');
    html = (
      <div className={cssClass}>
        <div className="inner">
          <div className="video-img-wrapper" onClick={props.clickMobile}>
            {ht}
          </div>
          <div className="title-wrapper">
            <h3>{title}</h3>
          </div>

          <div className="desc-wrapper">
            <p>{limitText(desc)}</p>
          </div>

          <div className="book-now-wrappr">
            <a href={getUrl2() + props.link}>READ MORE {">>"}</a>
          </div>
        </div>
      </div>
    );
  }
  return html;
};

export const VideoSliderItem3 = (props) => {
  const desc = props.desc != undefined ? props.desc : "";
  const cssClass = "cites-slider concert-slider-item" + props.cssClass;

  const doBlank = props.doBlank != undefined ? props.doBlank : "";

  let target = "";
  if (doBlank) {
    target = "_blank";
  }
  return (
    <div className={cssClass}>
      {/* <Link to={props.link} target={target} className="read-more-link" /> */}
      <div className="concert-img-wrapper" onClick={props.click}>
        <Img desktopImg={props.img} />
        <div className="video-play-img-wrapper">
          <Img desktopImg={"Videos/play.png"} />
        </div>
      </div>
      <div className="title-wrapper">
        <h3>{props.title}</h3>
      </div>

      <div className="desc-wrapper">
        <p>{limitText(desc)}</p>
      </div>

      <div className="book-now-wrappr">
        <a href={props.link} target={target}>
          READ MORE {">>"}
        </a>
      </div>
    </div>
  );
};

export const VideoSliderItem = (props) => {
  const desc = props.desc != undefined ? props.desc : "";
  const cssClass = "cites-slider video-slider-item " + props.cssClass;
  const doBlank = props.doBlank != undefined ? props.doBlank : "";
  let target = "";
  if (doBlank) {
    target = "_blank";
  }
  return (
    <div className={cssClass}>
      <div className="inner">
        <Link to={props.link} target={target} className="read-more-link" />
        <div className="video-img-wrapper" onClick={props.click}>
          <Img desktopImg={props.img} />
          <div className="video-play-img-wrapper">
            <Img desktopImg={"Videos/play.png"} />
          </div>
        </div>
        <div className="title-wrapper">
          <a href={props.link} target={target}>
            {" "}
            <h3>{limitText(props.title, 50)}</h3>
          </a>
        </div>

        <div className="desc-wrapper">
          <p>{limitText(desc)}</p>
        </div>

        <div className="book-now-wrappr">
          <a href={props.link} target={target}>
            READ MORE {">>"}
          </a>
        </div>
      </div>
    </div>
  );
};

export const ConcertSliderItem = (props) => {
  const desc = props.desc;
  let cssClass = "cites-slider concert-slider-item " + props.cssClass;
  if (props.isTodayBigger === true) {
    cssClass += " ac-disabled addOpacity ";
  }
  const doBlank = props.doBlank != undefined ? props.doBlank : "";

  let target = "";
  if (doBlank) {
    target = "_blank";
  }
  return (
    <div className={cssClass}>
      <Link to={props.link} target={target} className="read-more-link" />
      <div className="concert-img-wrapper" onClick={props.click}>
        <Img desktopImg={props.img} />
      </div>
      <div className="title-wrapper">
        <h3>{props.title}</h3>
      </div>

      <div className="desc-wrapper">
        <p>{limitText(props.desc)}</p>
      </div>

      <div className="book-now-wrappr">
        <a href={props.link}>READ MORE {">>"}</a>
      </div>
    </div>
  );
};

export const PostSliderItem = (props) => {
  const desc = props.desc != undefined ? props.desc : "";
  const cssClass = "cites-slider concert-slider-item" + props.cssClass;

  const doBlank = props.doBlank != undefined ? props.doBlank : "";

  let target = "";
  if (doBlank) {
    target = "_blank";
  }
  return (
    <div className={cssClass}>
      <Link to={props.link} target={target} className="read-more-link" />
      <div className="concert-img-wrapper" onClick={props.click}>
        <Img desktopImg={props.img} />
      </div>
      <div className="title-wrapper">
        <h3>{props.title}</h3>
      </div>

      <div className="desc-wrapper">
        <p>{limitText(desc)}</p>
      </div>

      <div className="book-now-wrappr">
        <a href={props.link}>READ MORE {">>"}</a>
      </div>
    </div>
  );
};

export const InstagremSliderItem = (props) => {
  const desc = props.desc;
  const cssEClass = props.cssClass !== undefined ? props.cssClass : "";
  const cssClass = "cites-slider concert-slider-item " + cssEClass;

  return (
    <div className={cssClass}>
      <div className="insta-img-wrapper" onClick={props.click}>
        <Img desktopImg={props.img} />
        <div className="insta-icon-wrapper">
          <Img desktopImg={"insta-icon.png"} />
        </div>
      </div>
      <div className="title-wrapper">
        <h3>@{props.title}</h3>
      </div>
    </div>
  );
};
export const GallerSideBarItem = (props) => {
  return (
    <div className="cites-slider gallery-slider-item align-center">
      <Link to={props.link} className="read-more-link" />
      <div className="gallery-img-wrapper">
        <Img desktopImg={props.img} />
      </div>
      <div className="title-wrapper">
        <h3>{props.title}</h3>
      </div>
    </div>
  );
};

export const ImgAndText = (props) => {
  const cssClass = "box col col-50 " + props.cssClass;
  return (
    <div className={cssClass}>
      {!props.external && (
        <Link
          target={"blank"}
          to={props.link}
          className="read-more-link"
          aria-label={props.text}
        />
      )}
      <div className="inner">
        {!props.external ? (
          <Img desktopImg={props.img} mobileImg={props.img_mob} />
        ) : (
          <a
            href={props.link}
            target="_blank"
            aria-label={props.text}
            rel="noopener"
          >
            <Img desktopImg={props.img} mobileImg={props.img_mob} />
          </a>
        )}
        <div className="link-wrapper">
          {props.external ? (
            <a href={props.link} target="_blank" rel="noopener">
              <h3>{props.text}</h3>
            </a>
          ) : (
            <Link to={props.link} target={"_blank"}>
              <h3>{props.text}</h3>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export const ImgAndText2 = (props) => {
  const cssClass = "box col" + props.cssClass;
  return (
    <div className={cssClass}>
      <Link
        target={"blank"}
        to={props.link}
        className="read-more-link"
        aria-label={props.text.replace(" >", "")}
      />
      <div className="inner">
        <Img desktopImg={props.img} mobileImg={props.img_mob} />
        <div className="link-wrapper">
          <Link
            to={props.link}
            target={"_blank"}
            aria-label={props.text.replace(" >", "")}
          >
            <h3>{props.text}</h3>
          </Link>
        </div>
      </div>
    </div>
  );
};

export const FaqItem = (props) => {
  let cssClass = "faq-answer close";
  let cssClass2 = "icon-wrapper closeIcon";
  let closeImg = "faqplus.png";

  if (props.isOpen === true) {
    cssClass = "faq-answer open";
    cssClass2 = "icon-wrapper openIcon";
    closeImg = "faqminus.png";
  }

  const ht = props.answer;
  return (
    <div className="faq-q-wrapper">
      <div className="faq-q" onClick={props.click}>
        <h3>{props.q}</h3>

        <div className={cssClass2}>
          <Img desktopImg={closeImg} />
        </div>
      </div>
      <div className={cssClass} dangerouslySetInnerHTML={{ __html: ht }}></div>
    </div>
  );
};

export const CoverSection = (props) => {
  const desktopImg = props.desktopImg;
  const mobileImg = props.mobileImg;
  const cssClass = props.cssClass;
  const pageTitleRowUp = props.pageTitleRowUp;
  const pageTitleRowDown = props.pageTitleRowDown;

  return (
    <section
      className={"ac-cover-section ac-cover-section-" + cssClass}
      id="part-1"
    >
      <Img desktopImg={desktopImg} mobileImg={mobileImg} />
      <h1>
        <span>{pageTitleRowUp}</span>
        <br />
        {pageTitleRowDown}
      </h1>
      {/* <div className="weather-wrapper show-on-mobile">
            <WeatherIcon label={"WATER TEMP"} temp={props.waterTemp}/>
            <WeatherIcon label={"TEL AVIV"} temp={props.telAvivWeather}/>
            <WeatherIcon label={"JERUSALEM"} temp={props.jerusalemWeather}/>
          </div>*/}
    </section>
  );
};

export const HomeDeals = (props) => {
  const title = props.title;
  const category = props.category;
  return (
    <div className={`ac-deals ${category}`}>
      <HomeTitle>
        <Link to={"/Pages/bestDeals"} className="ac-book-holiday">
          {title}
        </Link>
      </HomeTitle>
      <Deals category={category} />
    </div>
  );
};

export const HomeSlider = (props) => {
  const getParameterByName = function(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
      results = regex.exec(window.location.search);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  };

  var currentLang =
    localStorage.getItem("currentLang") != null
      ? localStorage.getItem("currentLang")
      : "uk";
  var langsArray = ["uk", "cz", "ro", "dk", "se", "hu", "nl"];

  // alert(currentLang);

  var l = getParameterByName("lang");

  /// check to see if  in array
  if (l != "" && langsArray.indexOf(l) !== -1) {
    currentLang = l;
  }

  localStorage.setItem("currentLang", currentLang);

  if (localStorage.getItem("currentLang") != null) {
    l = localStorage.getItem("currentLang");
  }

  const bannerSliderSettings = {
    dots: false,
    infinite: true,
    fade: true,
    cssEase: "linear",
    autoplay: true,
    lazyLoad: "ondemand",
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  let html = (
    <SimpleSlider settings={bannerSliderSettings}>
      <div>
        <Link to={"/Pages/bestDeals"}>
          <Img
            desktopImg={"HomeSlider/3.jpg"}
            mobileImg={"HomeSlider/M/3.jpg"}
          />
        </Link>
      </div>
    </SimpleSlider>
  );

  const isHomeSlider =
    props.isHomeSlider !== undefined ? props.isHomeSlider : false;

  if (isHomeSlider === true) {
    if (window.innerWidth < 1000) {
      //   html = <Img mobileImg={'/HomeSlider/M/douze.jpg'} />;
      // }else {
      // html = <div className="ac-responsive-video">
      // <iframe className="ac-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/5PAjhoH0NWU?mute=1&autoplay=1&playlist=5PAjhoH0NWU&rel=0&controls=0&loop=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      //  </div>
      //   html = <Img desktopImg={"/1920-500.jpg"} />;
      // }
      html = (
        <div className="ac-main-video-wrapper">
          <div className="ac-mainvideo-overlay">
            <div className="ac-innermainvideo-overlay"></div>
          </div>
          <ResponsiveYouTubeMainIframe vidId="XU2yB_xh5hQ" />
          {/* <ResponsiveYouTubeMainIframe vidId="eoeOj6WlrqY" /> */}
          {/* <VideoCover vidId={"eoeOj6WlrqY"} titleRowOne={""} titleRowTwo={""} /> */}
          {/* <ResponsiveYouTubeMainIframe vidId="CV2TtpIHrrk" /> */}
          {/* <ResponsiveYouTubeMainIframe vidId="Fc-upLDjD9g" /> */}
          {/*<App_Iframe  vidSrc={'./assets/video/mob.mp4'} isVideo={true}  id={'ac-video-opening-mob'}/> */}
        </div>
      );
      // html = (
      //   <SimpleSlider settings={bannerSliderSettings}>
      //     <div>
      //       <Img mobileImg={'HomeSlider/M/' + currentLang + '/3.jpg'} />
      //     </div>
      //   </SimpleSlider>
      // );
    } else {
      html = (
        <div className="ac-main-video-wrapper">
          <ResponsiveYouTubeMainIframe vidId="9yV6Z3kJctg" />
          {/* <VideoCover vidId={"eoeOj6WlrqY"} titleRowOne={""} titleRowTwo={""} /> */}
          {/* <ResponsiveYouTubeMainIframe vidId="eoeOj6WlrqY" /> */}
          {/* <ResponsiveYouTubeMainIframe vidId="CV2TtpIHrrk" /> */}
          {/* <ResponsiveYouTubeMainIframe vidId="Fc-upLDjD9g" /> */}
        </div>
      );
    }
  } else {
    if (window.innerWidth < 1000) {
      html = (
        <SimpleSlider settings={bannerSliderSettings}>
          <div>
            <Img mobileImg={"HomeSlider/M/" + currentLang + "/3.jpg"} />
          </div>
        </SimpleSlider>
      );
    } else {
      html = (
        <SimpleSlider settings={bannerSliderSettings}>
          <div>
            <Link to={"/Pages/bestDeals"}>
              <Img
                desktopImg={"HomeSlider/desktop/" + currentLang + "/1a.jpg"}
              />
            </Link>
          </div>

          {/*<div>
                            <Link to={'/Pages/bestDeals'}>
                              <Img 
                                 desktopImg={"HomeSlider/desktop/"+ currentLang +"/2a.jpg"} 
                              />
                            </Link>
                          </div>
                       
                         <div>
                            <Link to={'/Pages/bestDeals'}>
                              <Img 
                                 desktopImg={"HomeSlider/desktop/"+ currentLang +"/3a.jpg"} 
                              />
                            </Link>
                          </div>
                      
                         <div>
                            <Link to={'/Pages/bestDeals'}>
                              <Img 
                                 desktopImg={"HomeSlider/desktop/"+ currentLang +"/4a.jpg"}
                              />
                            </Link>
                          </div>

                          <div>
                            <Link to={'/Pages/bestDeals'}>
                              <Img 
                                 desktopImg={"HomeSlider/desktop/"+ currentLang +"/5a.jpg"}
                              />
                            </Link>
                          </div>

                          <div>
                            <Link to={'/Pages/bestDeals'}>
                              <Img 
                                 desktopImg={"HomeSlider/desktop/"+ currentLang +"/6a.jpg"}
                              />
                            </Link>
                          </div>*/}
        </SimpleSlider>
      );
    }
  }
  let textCurrent = props.textH || "";
  return (
    <section
      className="home-section caruasel-wrapper banners-caruasel-wrapper"
      id="part-1"
    >
      {html}
      <h1>{textCurrent}</h1>
      {/*<div className="weather-wrapper show-on-mobile">
            <WeatherIcon label={"Water Temp"} temp={props.waterTemp}/>
            <WeatherIcon label={"Tel Aviv"} temp={props.telAvivWeather}/>
            <WeatherIcon label={"Jerusalem"} temp={props.jerusalemWeather}/>
          </div>*/}
    </section>
  );
};

export const AnimateCallToAction = (props) => {
  const cssClass = props.cssClass;
  return (
    <a
      href={props.link}
      target="_blank"
      rel="noopener"
      className={cssClass}
      aria-label="Become an expert agent"
    >
      <Img desktopImg={props.src} mobileImg={props.srcMob} />
    </a>
  );
};

export const ActivaImg = (props) => {
  return (
    <div className="video-img-wrapper" onClick={props.click}>
      <Img desktopImg={props.src} />
      <div className="video-play-img-wrapper">
        <Img desktopImg={"Videos/play.png"} className="video-play-ggg" />
      </div>
    </div>
  );
};

export const TravelAlert = (props) => {
  // let placeText1 = 'Travel Alert: Get the latest travel alerts impacting Israel';
  // let linkTo = '/Pages/CoronaVirusPage';
  // let placeText2 = ' here';
  // let placeText3 = '';

  let placeText1 = "";
  let placeText2 = "";
  let placeText3 = "";
  let toLink = "";

  return (
    <section className="home-section home-section-padding" id="travel-alert">
      <div className="container ac-flex">
        <div className="ac-travel-alert-message col-80">
          <p>
            <NavLink exact to={props.toLink}>
              {props.placeText1}
              <span>{props.placeText2}</span>
              {props.placeText3}
            </NavLink>
          </p>
        </div>
        <div className="ac-travel-alert-close-wrapper col-20">
          <button className="ac-travel-alert-close" onClick={props.click}>
            <span>Close</span>
          </button>
        </div>
        <div className="clear"></div>
      </div>
    </section>
  );
};

export const SearchBar = (props) => {
  const keyWord = props.keyWord;
  const cssClasswrapper = props.cssClasswrapper;
  const clickForResults = props.clickForResults;
  // const cssClassPopupOpen = props.cssClassPopupOpen;
  const blurOut = props.blurOut;
  const Change = props.Change;
  const click = props.click;
  const keyUp = props.keyUp;

  return (
    <div className={cssClasswrapper}>
      <div className="ac-wrapper-input">
        <button className="ac-close-search ac-show-on-mobile" onClick={click}>
          <svg width="20" height="20" viewBox="0 0 20 20" className="st2jy5x">
            <path
              fill="#007CBA"
              fill-rule="nonzero"
              d="M7.712 4a2.14 2.14 0 0 1-.284 2.927L4.996 9.045H19v1.913H4.996l2.432 2.116c.857.745.981 2.03.284 2.926L1 10l6.712-6z"
            ></path>
          </svg>
        </button>

        <button className="ac-show-results" onClick={clickForResults}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="40"
            height="40"
            viewBox="0 0 20 20"
            className="s174epxq"
          >
            <path
              fill="#0067b9"
              fillRule="nonzero"
              d="M22.021 20.611l-4.83-4.83a8.51 8.51 0 1 0-1.41 1.41l4.83 4.83 1.41-1.41zm-18-10.09a6.5 6.5 0 1 1 6.5 6.5 6.51 6.51 0 0 1-6.5-6.5z"
            ></path>
          </svg>
        </button>

        <input
          key="random1"
          value={keyWord}
          placeholder={isMobile() ? "SEARCH" : "Start typing..."}
          onKeyUp={keyUp}
          onBlur={blurOut}
          onChange={Change}
        />
        <button className="ac-close-search ac-hide-on-mobile" onClick={click}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 20 20"
            className="s1bbg4gd"
          >
            <path
              fill="#0067b9"
              fillRule="nonzero"
              d="M13.72 3.22l1.06 1.06L10.06 9l4.72 4.72-1.06 1.06L9 10.06l-4.72 4.72-1.06-1.06L7.94 9 3.22 4.28l1.06-1.06L9 7.94l4.72-4.72z"
            ></path>
          </svg>
        </button>
      </div>
      {/*<SearchPopup cssClassPopupOpen={"ac-close"} className={cssClassPopupOpen}/>*/}
    </div>
  );
};

export const SearchBtn = (props) => {
  const cssClass = props.cssClass;
  const click = props.click;
  const onHoverLeave = props.onHoverLeave;
  const onHover = props.onHover;

  return (
    <button aria-label="search" className={cssClass} onClick={click}>
      <span>Search</span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 20 20"
        className="s174epxq"
      >
        <path
          fill="#0067b9"
          fillRule="nonzero"
          d="M22.021 20.611l-4.83-4.83a8.51 8.51 0 1 0-1.41 1.41l4.83 4.83 1.41-1.41zm-18-10.09a6.5 6.5 0 1 1 6.5 6.5 6.51 6.51 0 0 1-6.5-6.5z"
        ></path>
      </svg>
    </button>
  );
};

export const IconInfo = (props) => {
  const wrapperCss = props.wrapperCss;
  const img = props.img;
  const href = props.href;
  const title = props.title;
  const num = props.num;

  return (
    <a
      href={href}
      className={"ac-iconinfo ac-iconinfo-" + wrapperCss + " ac-flex"}
      target="_blank"
      rel="noopener"
      onClick={()=>TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'homepage_sub_menu', 'click_cta':title,}})}

    >
      <div className="ac-inner-iconinfo ac-inner-iconinfo-1">
        <Img desktopImg={img} />
      </div>
      <div className="ac-inner-iconinfo ac-inner-iconinfo-2 ac-flex ac-flex-column">
        <span className="ac-iconinfotitle ac-purple">{title}</span>
        <span className="ac-iconinfonum">{num}</span>
      </div>
    </a>
  );
};

export const IconTravelLink = (props) => {
  const wrapperCss = props.wrapperCss;
  const img = props.img;
  const imgHover = props.imgHover;
  const title = props.title;
  const link = props.link;
  const [isHover, setIsHover] = useState(false);
  const isIconLinkHoverd =
    props.isIconLinkHoverd !== undefined ? props.isIconLinkHoverd : false;
  let html;

  if (!isHover) {
    html = (
      <div className="ac-wrapper-content">
        <Img desktopImg={img} />
        <h3 className="ac-icontraveltitle ac-black">{title}</h3>
      </div>
    );
  } else {
    html = (
      <div className="ac-wrapper-content ac-hover">
        <Img desktopImg={imgHover} />
        <h3 className="ac-icontraveltitle ac-white">{title}</h3>
      </div>
    );
  }

  return (
    <div className={"ac-icontravel ac-icontravel-" + wrapperCss + " ac-flex"}>
      <a
        href={link}
        target="_blank"
        rel="noopener"
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
      >
        {html}
      </a>
    </div>
  );
};

export const BoxWithLinks = (props) => {
  const wrapperCss = props.wrapperCss;
  const img = props.img;
  const imgHover = props.imgHover;
  const title = props.title;
  const links = props.links;
  const text = props.text;
  const imgMob = props.imgMob;
  const [isHover, setIsHover] = useState(false);

  let html;

  if (!isHover) {
    html = (
      <div
        className={`ac-wrapper-content ${
          isMobile() ? "ac-hover ac-hover-mobile" : ""
        }`}
      >
        <Img desktopImg={img} mobileImg={imgMob} />
        <h3 className="ac-boxwithlinkstitle ac-black">{title}</h3>
        <div className="ac-bg-hover">
          <p>{text}</p>
          <div className="ac-wrapper-links">{props.children}</div>
        </div>
      </div>
    );
  } else {
    html = (
      <div
        className={`ac-wrapper-content ac-hover ${
          isMobile() ? "ac-hover-mobile" : ""
        }`}
      >
        <Img desktopImg={img} mobileImg={imgMob} />
        <h3 className="ac-boxwithlinkstitle ac-black">{title}</h3>
        <div className="ac-bg-hover">
          <p>{text}</p>
          <div className="ac-wrapper-links">{props.children}</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={"ac-boxwithlinks ac-boxwixlinks-" + wrapperCss + " ac-flex"}
      onMouseEnter={() => {
        setIsHover(true);
      }}
      onMouseLeave={() => {
        isMobile() ? null : setIsHover(false);
      }}
    >
      {html}
    </div>
  );
};

export const BoxWithLinksNew = (props) => {
  const wrapperCss = props.wrapperCss;
  const img = props.img;
  const imgHover = props.imgHover;
  const title = props.title;
  const links = props.links;
  const text = props.text;
  const imgMob = props.imgMob;
  const imgMap = props.imgMap;
  const imgMobMap = props.imgMobMap;
  const [isHover, setIsHover] = useState(false);

  let html;

  if (!isHover) {
    html = (
      <div
        className={`ac-wrapper-content ${
          isMobile() ? "ac-hover ac-hover-mobile" : ""
        }`}
      >
        <Img desktopImg={img} mobileImg={imgMob} />
        <div className="ac-title">
          <h3 className="ac-boxwithlinkstitle ac-black">
            <div className="ac-map-circle">
              <Img desktopImg={imgMap} mobileImg={imgMobMap} />
            </div>
            {title}
          </h3>
        </div>
        <div className="ac-bg-hover">
          <div className="ac-wrapper-links">{props.children}</div>
        </div>
      </div>
    );
  } else {
    html = (
      <div
        className={`ac-wrapper-content ac-hover ${
          isMobile() ? "ac-hover-mobile" : ""
        }`}
      >
        <Img desktopImg={img} mobileImg={imgMob} />

        <div className="ac-title">
          <h3 className="ac-boxwithlinkstitle ac-black">
            <div className="ac-map-circle">
              <Img desktopImg={imgMap} mobileImg={imgMobMap} />
            </div>
            {title}
          </h3>
        </div>

        <div className="ac-bg-hover">
          <div className="ac-wrapper-links">{props.children}</div>
        </div>
      </div>
    );
  }

  return (
    <div
      className={"ac-boxwithlinks ac-boxwixlinks-" + wrapperCss + " ac-flex"}
      onMouseEnter={() => {
        setIsHover(true);
      }}
      onMouseLeave={() => {
        isMobile() ? null : setIsHover(false);
      }}
    >
      {html}
    </div>
  );
};

export const BoxLink = (props) => {
  const wrapperCss = props.wrapperCss;
  const img = props.img;
  const imgArrowBlack = props.imgArrowBlack;
  const imgArrowBlackMob = props.imgArrowBlackMob;
  const imgArrowWhite = props.imgArrowWhite;
  const imgArrowWhiteMob = props.imgArrowWhiteMob;
  const imgMob = props.imgMob;
  const title = props.title;
  const imgClock = props.imgClock;
  const daysTitle = props.daysTitle;
  const link = props.link;
  const linkBlank = props.linkBlank || "_blank";
  const [isShown, setIsShown] = useState(false);
  const isRecomItine =
    props.isRecomItine !== undefined ? props.isRecomItine : false;
  const isImgLink = props.isImgLink !== undefined ? props.isImgLink : false;
  let html;
  let dayTourHtml;
  const scrollToElm = (linkBlank) => {
    var hash = linkBlank;
    console.log("hash: ", hash);
    var the_id = hash.substring(1);
    // console.log("the_id: ", the_id);
    if (hash) {
      // Desktop variables
      var element = document.getElementById(the_id);
      var $header = document.querySelector(".menu-outer-wrapper .container2");
      var viewportOffsetHeader = $header.getBoundingClientRect();
      var $header_h = viewportOffsetHeader.height;

      // MObile variables
      var $headerMob1 = document.querySelector(
        ".menu-outer-wrapper .container-flued"
      );
      var $viewportOffsetHeaderMob1 = $headerMob1.getBoundingClientRect();
      var $header1_mob_h = $viewportOffsetHeaderMob1.height;
      var $headerMob2 = document.querySelector(
        ".menu-outer-wrapper .container2"
      );
      var $viewportOffsetHeaderMob2 = $headerMob2.getBoundingClientRect();
      var $header2_mob_h = $viewportOffsetHeaderMob2.height;
      var $headermobile_h = $header1_mob_h + $header2_mob_h;
      console.log($headermobile_h);

      // var offset = 200;
      var offset = 0;
      var viewportOffset = element.getBoundingClientRect();
      const top = viewportOffset.top;

      var newTop = top - $header_h;
      if (window.innerWidth < 1000) {
        var newTop = top - $headermobile_h;
      }
      window.scrollTo({
        duration: 1500,
        delay: 100,
        smooth: true,
        offset: newTop, // Scrolls to element + 50 pixels down the page
      });
    }
  };

  if (isRecomItine) {
    dayTourHtml = (
      <div className="ac-days-tour">
        <Img desktopImg={imgClock} />
        <span>{daysTitle}</span>
      </div>
    );
  } else {
    dayTourHtml = null;
  }

  if (isImgLink) {
    html = <Img desktopImg={img} mobileImg={imgMob} />;
  } else {
    html = (
      <div className="ac-text">
        <h2>{props.mainTitle}</h2>
        <br />
        <p>{props.text}</p>
      </div>
    );
  }

  return (
    <div className={"ac-boxlink ac-boxlink-" + wrapperCss + " ac-flex"}>
      <a
        href={link}
        target={linkBlank}
        rel="noopener"
        onMouseEnter={() => setIsShown(true)}
        onMouseLeave={() => setIsShown(false)}
        onClick={() => scrollToElm(link)}
      >
        {html}
        {dayTourHtml}

        <div className="ac-inner-boxlink ac-flex">
          <div className="ac-subinner-boxlink">
            <h3 className="ac-boxlinktitle ac-black">{title}</h3>
            <Img
              desktopImg={imgArrowBlack}
              mobileImg={imgArrowBlackMob}
              imgCss="ac-arrow-boxlink"
            />
          </div>
          {isShown && (
            <div className="ac-subinner-boxlink-hover ac-flex">
              <h3 className="ac-boxlinktitle ac-white">{title}</h3>
              <Img
                desktopImg={imgArrowWhite}
                mobileImg={imgArrowWhiteMob}
                imgCss="ac-arrow-boxlink"
              />
            </div>
          )}
        </div>
      </a>
    </div>
  );
};

export const CardPost = (props) => {
  const wrapperCss = props.wrapperCss;
  const img = props.img;
  const title = props.title;
  const link = props.link;
  const imgMob = props.imgMob;
  const smlDesc = props.smlDesc;
  const [isHover, setIsHover] = useState(false);

  let hoveredCss;

  if (isHover) {
    hoveredCss = "ac-hovered";
  } else {
    hoveredCss = "";
  }

  return (
    <div
      className={"ac-card-post ac-card-post-" + wrapperCss + " ac-flex"}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <a href={link}>
        <div className={"ac-card-post-content" + hoveredCss}>
          <Img desktopImg={img} mobileImg={imgMob} imgCss={hoveredCss} />
          <h3 className="ac-card-post-title ac-black">{title}</h3>
          <h3 className="ac-card-post-desription ac-black">{smlDesc}</h3>
        </div>
      </a>
    </div>
  );
};

export const ParalaxBg = (props) => {
  const cssClass = props.cssClass;
  const titleRowOne = props.titleRowOne;
  const titleRowTwo = props.titleRowTwo;
  const style = props.style;
  const id = props.id;
  return (
    <section className={"ac-paralax " + cssClass} id={id} style={style}>
      <h1>
        {titleRowOne}
        <br />
        {titleRowTwo}
      </h1>
    </section>
  );
};

export const VideoCover = (props) => {
  const [muted, setMutted] = useState(true);
  const [playing, setPlaying] = useState(true);

  const cssClass = props.cssClass;
  const cssClassVideo = props.cssClassVideo;
  const titleRowOne = props.titleRowOne;
  const titleRowTwo = props.titleRowTwo;
  const style = props.style;
  const id = props.id;
  const vidId = props.vidId;

  const handleVideoSound = (id) => {
    if (muted == true) {
      setMutted(false);
    } else {
      setMutted(true);
    }
  };

  const handleVideoPlay = (id) => {
    if (playing == true) {
      setPlaying(false);
    } else {
      setPlaying(true);
    }
  };

  return (
    <section className={"ac-video-cover " + cssClass} id={id} style={style}>
      {/* <ResponsiveYouTubeIframe vidId={vidId} cssClassVideo /> */}
      <div className="responisve-iframe" aria-label=" סרטון ראשי">
        <ReactPlayer
          url={"https://www.youtube.com/watch?v=" + vidId}
          muted={muted}
          playing={playing}
          controls
          loop
          width="100%"
          height="100%"
        />
      </div>
      <div className={"ac-sound-wrapper"}>
        <button
          id={"video-sound-on-off-btn"}
          className={"ac-sound-btn ac-hide-on-mobile"}
          aria-label="sound button"
          onClick={() => {
            {
              handleVideoSound("iframe");
            }
          }}
        >
          {!muted == false ? (
            // <APP_IMG desktopImg={'volume.svg'} cssClass="ac-sound-img" />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="#fff"
              width="42"
              height="42"
              icon="VolumeUp"
            >
              <path
                fill-rule="evenodd"
                d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zm5.274-.147a1 1 0 011.414 0A9.972 9.972 0 0119 10a9.972 9.972 0 01-2.929 7.071 1 1 0 01-1.414-1.414A7.971 7.971 0 0017 10a7.97 7.97 0 00-2.343-5.657 1 1 0 010-1.414zm-2.829 2.828a1 1 0 011.415 0A5.983 5.983 0 0115 10a5.984 5.984 0 01-1.757 4.243 1 1 0 01-1.415-1.415A3.984 3.984 0 0013 10a3.983 3.983 0 00-1.172-2.828 1 1 0 010-1.415z"
                clip-rule="evenodd"
              ></path>
            </svg>
          ) : (
            // <APP_IMG desktopImg={'volume-mute.svg'} cssClass="ac-sound-img" />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="#fff"
              width="42"
              height="42"
              icon="VolumeOff"
            >
              <path
                fill-rule="evenodd"
                d="M9.383 3.076A1 1 0 0110 4v12a1 1 0 01-1.707.707L4.586 13H2a1 1 0 01-1-1V8a1 1 0 011-1h2.586l3.707-3.707a1 1 0 011.09-.217zm2.91 4.217a1 1 0 011.414 0L15 8.586l1.293-1.293a1 1 0 111.414 1.414L16.414 10l1.293 1.293a1 1 0 01-1.414 1.414L15 11.414l-1.293 1.293a1 1 0 01-1.414-1.414L13.586 10l-1.293-1.293a1 1 0 010-1.414z"
                clip-rule="evenodd"
              ></path>
            </svg>
          )}
        </button>
        <button
          id={"video-play-on-off-btn"}
          className={"ac-play-btn ac-hide-on-mobile"}
          aria-label="sound button"
          onClick={() => {
            {
              handleVideoPlay("iframe");
            }
          }}
        >
          {!playing == false ? (
            // <APP_IMG desktopImg={'volume.svg'} cssClass="ac-sound-img" />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="#fff"
              // width={53}
              // height={53}
              icon="Pause"
            >
              <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zM7 8a1 1 0 012 0v4a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v4a1 1 0 102 0V8a1 1 0 00-1-1z"
                clip-rule="evenodd"
              ></path>
            </svg>
          ) : (
            // <APP_IMG desktopImg={'volume-mute.svg'} cssClass="ac-sound-img" />

            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="#fff"
              // width={53}
              // height={53}
              icon="Play"
            >
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z"
                clip-rule="evenodd"
              ></path>
            </svg>
          )}
        </button>
      </div>
      {/* <h1>
        {titleRowOne}
        <br />
        {titleRowTwo}
      </h1> */}
    </section>
  );
};

export const IsraelExpert = (props) => {
  const [isHover, setIsHover] = useState(false);

  let hoveredCss;

  if (isHover) {
    hoveredCss = "ac-hovered";
  } else {
    hoveredCss = "";
  }
  return (
    <div
      className="ac-israel-expert-link"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL +
          "/assets/img/Interests/israel-expert-link.jpg"})`,
      }}
    >
      <h2 className="ac-white">
        BECOME <br className="ac-show-on-cell" />
        AN ISRAEL <br className="ac-show-on-cell" />
        <br className="ac-hide-on-cell" />
        EXPERT AGENT
      </h2>
      <p>Learn about the Land of the Bible</p>
      <a
        href={"https://www.travelagentacademy.com/israeldestinationspecialist/"}
        className={hoveredCss}
        onMouseEnter={() => setIsHover(true)}
        onMouseLeave={() => setIsHover(false)}
        onClick={()=> TagManager.dataLayer({dataLayer: {'event':'auto_event','eventName':'generic_ click', 'element_location':'become an israel expert agent', 'click_cta':'click here',}})}
        target="_blank"
      >
        {/* <h3 className="ac-white">MORE INFO</h3> */}
        <h3 className="ac-white">CLICK HERE</h3>
        {/* {isHover ? (
          <Img desktopImg={"arrowwright.svg"} imgCss={"ac-btn-arrow"} />
        ) : (
          <Img desktopImg={"arrowbright.svg"} imgCss={"ac-btn-arrow"} />
        )} */}
      </a>
    </div>
  );
};

export const WeatherIconAgent = (props) => {
  const [Fahrenheit, setFahrenheit] = useState(true);
  const [Celcium, setCelcium] = useState(false);
  const active = "";
  //Fahrenheit
  let f = <p>{parseInt(props.temp * 1.8 + 32)}</p>;

  // Celcium
  let c = <p>{props.temp}</p>;

  const FahrenheitOpen = () => {
    if (Fahrenheit) {
      setFahrenheit(false);
    } else {
      setFahrenheit(true);
    }
  };
  const CelciumOpen = () => {
    if (Celcium) {
      setCelcium(false);
    } else {
      setCelcium(true);
    }
  };

  let imgPath = "WeatherIcon.png";
  let weatherClass = "weather-icon-wrapper-agents";
  if (props.temp === "149" || props.temp === "12") {
    f = <p>{parseInt(props.temp * 1.8 + 32)}</p>;
    imgPath = "WeatherIcon2.png";
    weatherClass = "weather-icon-wrapper-agents flight-icon-wrapper";
  }
  return (
    <div className={weatherClass}>
      <Img desktopImg={imgPath} />
      <span className={`ac-celcium ${Celcium ? "ac-active" : " "}`}>{c}</span>
      <button
        className={`ac-weather-btn  ac-celcium-btn ${
          Celcium ? "ac-active" : " "
        }`}
        onClick={() => CelciumOpen()}
        title="Click here to show the temperature in Celcium"
      >
        °C
      </button>
      <span className="ac-line"> | </span>
      <span className={`ac-fahrenheit ${Fahrenheit ? "ac-active" : " "}`}>
        {f}
      </span>
      <button
        className={`ac-weather-btn ac-fahrenheit-btn ${
          Fahrenheit ? "ac-active" : " "
        }`}
        onClick={() => FahrenheitOpen()}
        title="Click here to show the temperature in Fahrenheit"
      >
        °F
      </button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/Components/UI/UI.js